import React from "react";
import styles from "../index.module.scss";

const cx = (...classNames) => classNames.filter(Boolean).join(" ");

const Progress = ({ checkoutState, setCheckoutState }) => {
  const steps = [
    {
      label: "Contact Information",
      states: ["userdetails", "authentication"],
      number: 1,
    },
    { label: "Delivery Mode", states: ["delivery"], number: 2 },
    { label: "Checkout", states: ["summary", "processed"], number: 3 },
  ];

  // Find the index of the current step
  const currentStepIndex = steps.findIndex((step) =>
    step.states.includes(checkoutState)
  );

  return (
    <div className={styles.progressContainer}>
      {steps.map((step, index) => {
        const isCurrentOrPassed = index <= currentStepIndex;
        const isClickable = index <= currentStepIndex;

        return (
          <button
            key={index}
            type="button"
            onClick={() => {
              if (isClickable) setCheckoutState(step.states[0]);
            }}
            disabled={!isClickable}
            className={cx(
              styles.progressStep,
              isCurrentOrPassed && styles.active,
              !isClickable && styles.disabled,
            )}
          >
            <div className={styles.stepCircle}>{step.number}</div>
            <div className={styles.stepLabel}>{step.label}</div>
          </button>
        );
      })}
    </div>
  );
};

export default Progress;
